var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1239.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Premium",
    transform: "translate(1206.000000, 1239.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5633216,12 L15.9791279,30 L9.38794363,12 L22.5633216,12 Z M7.26428402,12 L12.4872982,26.426 L-4.70734562e-14,12 L7.26428402,12 Z M32,12 L19.4038474,26.427 L24.6917748,12 L32,12 Z M10.4664012,3 L7.40749248,10 L0.000399465715,10 L5.73073514,3 L10.4664012,3 Z M26.2268216,3 L31.9571573,10 L24.5490656,10 L21.4911556,3 L26.2268216,3 Z M19.3111713,3 L22.3690814,10 L9.58717715,10 L12.6460859,3 L19.3111713,3 Z",
    id: 213
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonPremium);
export default __webpack_public_path__ + "static/media/common-premium.08557de0.svg";
export { ForwardRef as ReactComponent };